import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v16h7v2h8v-2h7V3zm-2 14H3V5h18v12zm-5-7v2H8v-2h8z"
}), 'RemoveFromQueueSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RemoveFromQueueSharp.js
// module id = 5722
// module chunks = 2